import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { Proforma } from './proforma';
import { SharedService } from './../_shared/shared.service';


@Injectable({ providedIn: 'root' })
export class ProformaService {

	
	statuses: any = [
		{ value: 0, name: 'Draft' },
		{ value: 1, name: 'Published' },
		{ value: 2, name: 'Internal Only' },
		{ value: 3, name: 'Template' },
		{ value: 4, name: 'Request' },
	];

	visibilities: any = [
		{ value: 0, name: 'Public' },
		{ value: 1, name: 'Private' },
		{ value: 2, name: 'Internal' },
	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'proformas';

	add(proforma: Proforma): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(proforma));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, proforma);
	}

	update(proforma: Proforma): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, proforma);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getAllSentEmailProforma(proforma): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/sent-email/list`, proforma);
	}

	sendEmailOrSmsForBizdev(proforma): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/guest-portal/bizdev/email-text`, proforma);
	}

	//copy

	copyTo(proforma: Proforma): Observable<ApiResponse> {
		console.log('copying to... ' + JSON.stringify(proforma));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/copy`, proforma);
	}

	copyFromExistingProforma(proforma: Proforma): Observable<ApiResponse> {
		console.log('copying... ' + JSON.stringify(proforma));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/copy-from`, proforma);
	}

	generateOwnerLeadProforma(proforma: Proforma): Observable<ApiResponse> {
		console.log('copying... ' + JSON.stringify(proforma));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/owner-lead-proforma-copy`, proforma);
	}

	generateProformaCount(proforma: Proforma): Observable<ApiResponse> {
		console.log('copying to... ' + JSON.stringify(proforma));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/generateProformasCount`, proforma);
	}

	generateProformas(proforma: Proforma): Observable<ApiResponse> {
		console.log('copying to... ' + JSON.stringify(proforma));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/generateProformas`, proforma);
	}

	setTarget(proforma: Proforma): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/target`, proforma);
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	requestProforma(property: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/request-proforma`, property);
	}

	sendProformaToRealtor(property: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/send-realtor-proforma`, property);
	}

	sendProformaToOwner(payload: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/send-owner-proforma`, payload);
	}

	getViewStats(proformaId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${proformaId}/view-stats`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getViewStatsBatch(proformaIds: number[]): Observable<any> {
		return this.http.post(`${environment.apiUrl}/${this.urlEndpoint}/view-stats/batch`, { proformaIds });
	}

	sendBulkProforma(proforma: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/sendProformas`, proforma);
	}

	getVisibilityName(proforma: any) {
		if (proforma?.visibility != undefined) {
			const visibility = this.visibilities.find((e: any) => e.value == proforma.visibility);
			return visibility.name;
		}
		else {
			return '';
		}
	}
	
	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}

	getPdfAsBlob(confId: number): any {
		return this.http.get(`${environment.apiUrl}/proformas/${confId}/pdf`, {
			observe: 'response',
			responseType: 'blob'
		});
	}
}
